import { Customer } from '@sonar-software/sonar-core';
import { CustomerSettingsManager } from './CustomerSettingsManager';
import { FeatureFlagManager } from './FeatureFlagManager';
import { OidcProviderSetup } from './OidcProviderSetup';
import React from 'react';
import { ShardSearchEntryDetails } from '@sonar-software/sonar-admin';

export interface ConfigurationPanelProps {
	customer?: Customer | null;
	searchDetails?: ShardSearchEntryDetails;
}

export const ConfigurationPanel: React.FC<ConfigurationPanelProps> = ({ customer, searchDetails }) =>
	<>
		<OidcProviderSetup
			customerId={ customer?.id }
			shardName={ searchDetails?.shardName } />
		<CustomerSettingsManager
			customer={ customer }
			searchDetails={ searchDetails } />
		<FeatureFlagManager searchDetails={ searchDetails } />
	</>;
